import axios from 'axios';
import Cookies from 'js-cookie';
import qs from 'qs';

const isEmpty = (key, strict) => {
  if (typeof key === 'string') {
    // key = key.replace(/(^\s*)|(\s*$)/g, '');
    if (
      key === '' ||
      key === null ||
      key === undefined ||
      (strict && (key === 'null' || key === 'undefined'))
    ) {
      return true;
    } else {
      return false;
    }
  } else if (typeof key === 'undefined') {
    return true;
  } else if (typeof key === 'object') {
    for (let i in key) {
      return false;
    }
    return true;
  } else if (typeof key === 'boolean') {
    return false;
  }
};

const lightyear = {
  track(event, data, current_route) {
    const {
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      internal_campaign,
      internal_ref,
      internal_source,
      internal_medium,
      internal_term,
      internal_content,
      hmcu,
      hmpl,
      hmsr,
      hmkw,
      hmci,
      ref,
    } = qs.parse(window.location.search.substr(1));

    const scren_size = [window.screen.width, window.screen.height].sort(function(a, b) {
      return a - b;
    });

    let device_language = navigator.language;
    if (Array.isArray(device_language)) {
      device_language = device_language[0];
    }

    const eventCommonParam = {
      user: {
        user_id: Number(Cookies.get('kp.user_id')) || 0,
        browser_key: Cookies.get('kp.browser.key'),
      },
      when: {
        ts: new Date().getTime(),
      },
      where: {
        device_type: Number(10),
        platform: 'js',
        from_route: document.referrer,
        current_route: current_route
            ? window.decodeURIComponent(current_route)
            : window.decodeURIComponent(window.location.href),
        device_language,
        site_language: Cookies.get('hl') || 'en-us',
        user_agent: navigator.userAgent,
        country: document.documentElement.getAttribute('kp-country'),
        screen_size: scren_size,
        install_source: '',
      },
    };

    const howArr = [
      {
        key: 'utm',
        data: {
          utm_source,
          utm_medium,
          utm_campaign,
          utm_term,
          utm_content,
        },
      },
      {
        key: 'itm',
        data: {
          internal_campaign,
          internal_ref,
          internal_source,
          internal_medium,
          internal_term,
          internal_content,
        },
      },
      {
        key: 'baidu',
        data: {
          hmcu,
          hmpl,
          hmsr,
          hmkw,
          hmci,
        },
      },
      {
        key: 'refcode',
        data: { ref },
      },
    ];
    let howResult = {};
    for (let i = 0; i < howArr.length; i++) {
      const keys = Object.keys(howArr[i].data);
      let temp = {};
      keys.forEach((j) => {
        if (!isEmpty(howArr[i].data[j])) {
          if (Array.isArray(howArr[i].data[j])) {
            temp[j] = howArr[i].data[j][0];
          } else {
            temp[j] = howArr[i].data[j];
          }
        }
      });
      if (!isEmpty(temp)) {
        howResult = {
          ...howResult,
          ...temp,
        };
      }
    }
    if (Object.keys(howResult).length) {
      eventCommonParam['how'] = howResult;
    }
    return axios.post(
        'https://tracking-api.italki.com/v1/events',
        {
          what: event,
          ...eventCommonParam,
          data,
        },
        { timeout: 3000 },
    );
  },
};

export default lightyear;
